import type {BaseNodeType} from './../../../@polygonjs/polygonjs/src/engine/nodes/_Base';
import type {RootManagerNode} from './../../../@polygonjs/polygonjs/src/engine/nodes/manager/Root';
// import {PolyScene} from './../../../@polygonjs/polygonjs/src/engine/scene/PolyScene';
// export function initDefaultScene(scene: PolyScene) {
// 	const root = scene.root();

// 	// create a box and a sphere
// 	const geo = root.createNode('geo');

// 	return {scene, root, geo};
// }

export function addPerspectiveCameraOBJWithOrbitControls(root: RootManagerNode) {
	// create a camera
	const perspectiveCamera1 = root.createNode('perspectiveCamera');
	perspectiveCamera1.p.t.set([5, 5, 5]);
	// add orbitControls
	const events1 = perspectiveCamera1.createNode('eventsNetwork');
	const orbitsControls = events1.createNode('cameraOrbitControls');
	perspectiveCamera1.p.controls.setNode(orbitsControls);

	return {perspectiveCamera1};
}

interface ReturnedNodeData {
	node: BaseNodeType;
	children: Record<string, ReturnedNodeData>;
}
export type ReturnedNodeDataDict = Record<string, ReturnedNodeData>;
